import api from "../utils/api";
import axios from "axios";
import {
  REQUEST_GENERATE_REPORT,
  GENERATE_REPORT_SUCCESS,
  GENERATE_REPORT_FAILED,
  GENERATE_REPORT_IN_PROGRESS,
} from "./types";

export const generateReport = (params) => async (dispatch) => {
  dispatch({ type: REQUEST_GENERATE_REPORT });
  try {
    let res = await api.post("/tasks/generate-report", params);

    dispatch({ type: GENERATE_REPORT_IN_PROGRESS, payload: res.data });
  } catch (err) {
    dispatch({ type: GENERATE_REPORT_FAILED, payload: err.message });
  }
};

export const getStatus = (params) => async (dispatch) => {
  console.log("the test params", params);
  if (params.url !== undefined) {
   var res = await axios.get(params.url);
    console.log("the status is: ", res);
  }
  // Set status
  dispatch({ type: GENERATE_REPORT_SUCCESS, payload: res });
};
